import React, { useState, useContext } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Link from '@material-ui/core/Link'

import { Link as RouterLink } from 'react-router-dom'

import AccountCircle from '@material-ui/icons/AccountCircle'
import MenuIcon from '@material-ui/icons/Menu'

import CustomDrawer from '../CustomDrawer'

import _userContext from '../../contexts/userContext'

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 0,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
}))

export default function Header() {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const [drawerState, setDrawerState] = useState(false)

    const userContext = useContext(_userContext)

    const handleMenu = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handlePrifileLink = event => {
        handleClose()
    }

    const handleLogout = event => {
        handleClose()
        userContext.handleLogout()
    }

    const toggleDrawer = ev => {
        setDrawerState(!drawerState)
    }

    return (
        <>
            {userContext.isAuthenticated && (
                <header className={classes.root}>
                    <AppBar position="static">
                        <Toolbar>
                            <IconButton
                                edge="start"
                                className={classes.menuButton}
                                color="inherit"
                                aria-label="menu"
                                onClick={toggleDrawer}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                Админ. панель "my-energy-stream"
                            </Typography>
                            <div>
                                <IconButton
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                    color="inherit"
                                >
                                    <AccountCircle />
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={handlePrifileLink}>
                                        <Link
                                            component={RouterLink}
                                            to="/profile"
                                        >
                                            Профиль
                                        </Link>
                                    </MenuItem>
                                    <MenuItem onClick={handleLogout}>
                                        Выйти
                                    </MenuItem>
                                </Menu>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <nav>
                        <CustomDrawer
                            state={drawerState}
                            toggleDrawer={toggleDrawer}
                        />
                    </nav>
                </header>
            )}
        </>
    )
}
